"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WixClientDefinition = void 0;
const services_definitions_1 = require("@wix/services-definitions");
exports.WixClientDefinition = (0, services_definitions_1.defineService)('viewer-core/viewer-service-wix-client');
//# sourceMappingURL=index.js.map